import {Component, OnInit} from '@angular/core';
import {AlertService, UserService} from "../services";
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import {MatDialog} from "@angular/material/dialog";
import {ComponentTitleService} from "../services/componentTitle.service";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";

import { locale as polish } from './i18n/pl';
import {SupplierService} from "../services/supplier.service";
import {Product} from "../models/product";
import {ProductService} from "../services/product.service";
import {UnitService} from "../services/unit.services";
import {VatRateService} from "../services/vatRate.service";
import {Unit} from "../models/unit";
import {VatRate} from "../models/vatRate";
import {Supplier} from "../models/supplier";
import {fuseAnimations} from "../../../@fuse/animations";
import {MatSnackBar} from "@angular/material/snack-bar";
import {StorehouseUseService} from "../services/storehouseUse.service";
import {User} from "../models";
import {Items} from "../models/items";

@Component({
    templateUrl: './storehouseUseForm.component.html',
    styleUrls: ['./storehouseUseForm.component.scss'],
    animations   : fuseAnimations
})

export class StorehouseUseFormComponent implements OnInit {

    form: FormGroup;
    loading = false;
    submitted = false;
    id: string;
    isAddMode: boolean;
    suppliers: Supplier[];
    dialogRef: any;
    products: Product[];
    units: Unit[];
    vatRates: VatRate[];
    customers: any[];
    workers: any[];

    constructor(
        public _matDialog: MatDialog,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private supplierService: SupplierService,
        private storehouseUseService: StorehouseUseService,
        private productService: ProductService,
        private unitService: UnitService,
        private vatRateService: VatRateService,
        private _matSnackBar: MatSnackBar,
        private userService: UserService,
    ) {
        this.translationLoader.loadTranslations(polish);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Use');
    }

    ngOnInit() {
        this.userService.getAllCustomers().pipe(first()).subscribe((res: Items) => {
                this.customers = res.items;
            },
            error => {
                this.alertService.error(error);
            });

        this.userService.getAllWorkers().pipe(first()).subscribe((res: Items) => {
                this.workers = res.items;
            },
            error => {
                this.alertService.error(error);
            });

        this.productService.getAll().subscribe((res: Product[]) => {
            this.products = res;
        }, error => {
            this.alertService.error(error);
        });

        this.unitService.getAll().subscribe((res: Unit[]) => {
            this.units = res;
        }, error => {
            this.alertService.error(error);
        });

        this.id = this.route.snapshot.params['id'];
        this.isAddMode = !this.id;

        if (this.isAddMode) {
            this.componentTitleService.addPart('New');
        } else {
            this.componentTitleService.addPart('Edit');
        }

        this.form = this.formBuilder.group({
            customer: ['', Validators.required],
            worker: ['', Validators.required],
            items: this.formBuilder.array([]),
        });

        if (!this.isAddMode) {

        } else {
            this.addLine();
        }
    }

    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        // this.alertService.clear();

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;

        if (this.isAddMode) {
            this.createUse();
        } else {
            this.updateUse();
        }
    }

    newLine(): FormGroup {
        return this.formBuilder.group({
            id: [''],
            product: ['', Validators.required],
            unit: ['', Validators.required],
            quantity: ['', Validators.required],
        });
    }

    public addLine() {
        this.items().push(this.newLine());
    }

    public removeLine(lineIdx: number) {
        this.items().removeAt(lineIdx);
    }

    public items(): FormArray {
        return this.form.get('items') as FormArray;
    }

    public onProductSelect(lineIdx: number, event: any) {
        for (let i = 0; i < this.products.length; i++) {
            if (this.products[i].id != event.value) {
                continue;
            }

            if (typeof this.products[i].unit !== "undefined" && this.products[i].unit.id !== null) {
                this.items().at(lineIdx).get('unit').setValue(this.products[i].unit.id);
            }

            break;
        }
    }

    private createUse() {
        this.storehouseUseService.create(this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Use added successfully');
                    this.router.navigate(['.', { relativeTo: this.route }]);
                },
                error => {
                    this.loading = false;
                    this._matSnackBar.open('Use creation error - ' + error, 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-error']
                    });
                });
    }

    private updateUse() {
        this.storehouseUseService.update(this.id, this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Update successful');
                    this.router.navigate(['..', { relativeTo: this.route }]);
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                });
    }
}
